import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dialogWidth", "pulse", "testId", "targetNode", "target"];
import React from 'react';
import SpotlightInner from './spotlight-inner';
import { SpotlightConsumer } from './spotlight-manager';
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */
var Spotlight = function Spotlight(_ref) {
  var _ref$dialogWidth = _ref.dialogWidth,
    dialogWidth = _ref$dialogWidth === void 0 ? 400 : _ref$dialogWidth,
    _ref$pulse = _ref.pulse,
    pulse = _ref$pulse === void 0 ? true : _ref$pulse,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'spotlight' : _ref$testId,
    targetNode = _ref.targetNode,
    target = _ref.target,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SpotlightConsumer, null, function (_ref2) {
    var opened = _ref2.opened,
      closed = _ref2.closed,
      targets = _ref2.targets;
    // use the targetNode prop or try get the target from context targets using name
    var actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
    return actualTargetNode ? /*#__PURE__*/React.createElement(SpotlightInner, _extends({}, rest, {
      targetNode: actualTargetNode,
      target: target,
      onOpened: opened,
      onClosed: closed,
      testId: testId,
      dialogWidth: dialogWidth,
      pulse: pulse
    })) : null;
  });
};
export default Spotlight;